/*
 * O que esta implantação é: 'Platform' (o portal que gere as instâncias), 'Gym' (um ginásio) ou 'Combined' (o comportamento antigo).
 * Vem do servidor, uma vez; se não responder, assume-se 'Combined' — o que sempre existiu — para nunca deixar o utilizador sem ecrã.
 * Fora do portal, o servidor pode dizer também onde ele está (platformUrl): a consola e o login de operador encaminham para lá.
 */
let cached = null;

const FALLBACK = { mode: 'Combined', platformUrl: '' };

export const getDeploymentInfo = () => {
  if (cached) return cached;
  cached = (async () => {
    try {
      if (typeof fetch !== 'function') return FALLBACK;
      const res = await fetch('/health/deployment', { headers: { Accept: 'application/json' } });
      if (!res.ok) return FALLBACK;
      const data = await res.json();
      const mode = ['Platform', 'Gym', 'Combined'].includes(data?.mode) ? data.mode : 'Combined';
      // Só um endereço http(s) absoluto serve de destino; qualquer outra coisa é ignorada.
      const platformUrl = mode !== 'Platform' && typeof data?.platformUrl === 'string' && /^https?:\/\//i.test(data.platformUrl)
        ? data.platformUrl.replace(/\/+$/, '')
        : '';
      return { mode, platformUrl };
    } catch {
      return FALLBACK;
    }
  })();
  return cached;
};

export const getDeploymentMode = async () => (await getDeploymentInfo()).mode;

/** Só para testes. */
export const resetDeploymentModeCache = () => { cached = null; };
